export var getSemverString = function (semver) {
    return semver
        ? ['major', 'minor', 'patch'].map(function (k) { return semver[k]; }).join('.')
        : undefined;
};
